import { cn } from './cn';
import { focusRing } from './focus';

/** A labelled colour well (the native picker): board background, pattern and organisation colours. */
export function ColorInput({
  label,
  value,
  onChange,
  disabled,
  className,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <label className={cn('flex items-center justify-between gap-2 font-sans text-sm text-fg', className)}>
      {label}
      <input
        type="color"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className={cn(
          'h-7 w-10 shrink-0 cursor-pointer rounded-md border border-border bg-surface p-0.5 disabled:cursor-default disabled:opacity-50 pointer-coarse:h-11 pointer-coarse:w-11',
          focusRing,
        )}
      />
    </label>
  );
}
